import { render, staticRenderFns } from "./picker-marketing.vue?vue&type=template&id=da84278a"
import script from "./picker-marketing.vue?vue&type=script&lang=js"
export * from "./picker-marketing.vue?vue&type=script&lang=js"
import style0 from "./picker-marketing.vue?vue&type=style&index=0&id=da84278a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports